<template lang="pug">
section
  .hero
    .hero-body
      .container
        h1.title Videos
        .columns.is-centered.is-multiline
          .column.is-half.is-flex(v-for="video in videos")
            .card(@click="openVideo(video.link)")
              .card-image
                figure.image
                  prismic-image(:field="video.thumbnail")
              .card-content
                .content
                  p.title.is-4 {{ video.title }}
                  p.subtitle.is-5 {{ video.description }}
                  b-button(type="is-danger", tag="a", :href="video.link", target="_blank")
                    span Watch on 
                    font-awesome-icon(:icon="['fab', 'youtube']")
</template>

<script>
export default {
  name: "Videos",

  data() {
    return {
      videos: []
    };
  },

  methods: {
    // Get YouTube video id
    getVideoID(url) {
      const match = url.match(/^.*v=(.+)$/);
      if (match) {
        return match[1];
      }
    },

    // Fetch videos from Prismic
    getVideos() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "video"), {
          orderings: "[my.video.date desc]",
          pageSize: 4
        })
        .then(response => {
          const results = response.results;
          this.videos = results.map(document => {
            return {
              title: document.data.title ? document.data.title[0].text : "",
              thumbnail: document.data.thumbnail,
              description: document.data.description
                ? document.data.description[0].text
                : "",
              date: document.data.date,
              link: document.data.link ? document.data.link["url"] : "",
              embed: document.data.link
                ? this.getVideoID(document.data.link["url"])
                : ""
            };
          });
        });
    },

    // Open video
    openVideo(videoLink) {
      window.open(videoLink, "_blank");
    }
  },

  created() {
    this.getVideos();
  }
};
</script>

<style lang="scss" scoped>
.card {
  -webkit-filter: brightness(100%);
}

.card:hover {
  -webkit-filter: brightness(70%);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
  cursor: pointer;
}
</style>
